import { render, staticRenderFns } from "./Nomina.vue?vue&type=template&id=663eb2bb&scoped=true&"
import script from "./Nomina.vue?vue&type=script&lang=js&"
export * from "./Nomina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663eb2bb",
  null
  
)

export default component.exports